import { render, staticRenderFns } from "./order-addshipment.vue?vue&type=template&id=89e9cfea&"
import script from "./order-addshipment.vue?vue&type=script&lang=ts&"
export * from "./order-addshipment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports